/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bright_Light_Wren_MeltInputs */

const en_bright_light_wren_melt = /** @type {(inputs: Bright_Light_Wren_MeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback groups`)
};

const de_bright_light_wren_melt = /** @type {(inputs: Bright_Light_Wren_MeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback-Gruppen`)
};

/**
* | output |
* | --- |
* | "Feedback groups" |
*
* @param {Bright_Light_Wren_MeltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bright_light_wren_melt = /** @type {((inputs?: Bright_Light_Wren_MeltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bright_Light_Wren_MeltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bright_light_wren_melt(inputs)
	return de_bright_light_wren_melt(inputs)
});